import styled from 'styled-components'
import { Tag } from 'core/components/ui'
import SVG from 'core/components/svg'
import { font, greys, lineHeight } from 'assets/themes/theme-default'

import { isMobile } from 'react-device-detect'

export const ContentWrapper = styled.div`
  padding: 10px 15px;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;
  border: solid ${greys.light1};
  border-width: 1px;
  transition: 0.2s;
  min-height: ${isMobile ? '220px' : '206px'};
  &&.selected {
    box-shadow: 1px 6px 4px -2px rgba(0, 0, 0, 0.15);
    border-left: 4px solid ${props => props.theme.colors.color1.bg};
  }
`
export const Title = styled.h4`
  // color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgxs};
  line-height: ${isMobile && 'normal'};
  margin: 0 0 5px 0;
`
export const Icon = styled(SVG)`
  width: 16px;
  height: 16px;
  fill: ${props => props.theme.colors.color1.bg};
  vertical-align: middle;
  margin: 0 8px 0 0;
`
export const DataWrapper = styled.p`
  margin: 0;
  line-height: ${font.size.lgxxs};
  font-size: ${font.size.base};
`

export const CustomTag = styled(Tag)`
  margin: 0;
  border: none;
  background: none;
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.bold};
  position: relative;
  padding: ${isMobile ? '3px 6px' : '3px 8px'};
  &&:hover {
    opacity: 1;
  }
  &&:before {
    content: '';
    opacity: 0.15;
    background-color: ${props => props.theme.colors.color1.bg};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 5px;
    padding: 2px 0;
  }
`

export const Badge = styled.p`
  margin: 0;
  display: inline;
  color: ${greys.light4};
  background-color: ${props => props.theme.colors.color1.bg};
  position: absolute;
  right: 10px;
  bottom: 10px;
  // top: ${isMobile ? '10px' : ''};

  height: ${lineHeight.base};
  width: ${lineHeight.base};
  border-radius: ${lineHeight.base};

  span {
    position: absolute;
    text-align: center;
    left: 0;
    right: 0;
    top: 1px;
  }
`
